import React from 'react'
import { compose, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import Infinite from 'react-infinite'

import {
  fetchFeaturedPolls,
  selectFeaturedPolls,
} from '../../stores/polls/featured'
import { hasMore } from '../../stores/cursoredUrlsStore'

import PollItem from './PollItem'

const ELEMENT_HEIGHT = 50

const renderLoading = () => {
  return (
    <div
      className="bg-white w-100 flex items-center ph3"
      style={{ height: ELEMENT_HEIGHT }}
    >
      Loading polls...
    </div>
  )
}

export function FeaturedPollsList({
  polls,
  hasMore,
  fetchFeaturedPolls,
  loading,
}) {
  if (!polls.length) return null
  return (
    <Infinite
      useWindowAsScrollContainer={true}
      elementHeight={ELEMENT_HEIGHT}
      infiniteLoadBeginEdgeOffset={2000}
      onInfiniteLoad={hasMore ? fetchFeaturedPolls : () => {}}
      isInfiniteLoading={loading}
    >
      {polls.map(poll => (
        <PollItem elementHeight={ELEMENT_HEIGHT} key={poll.id} poll={poll} />
      ))}
    </Infinite>
  )
}

export function FeaturedPolls({
  polls,
  loading,
  error,
  fetchFeaturedPolls,
  hasMore,
}) {
  return (
    <div>
      <div className="dt f6 w-100">
        <div className="word-wrap dt-row w-100 bg-op-con-dark white">
          <div className="dtc tc w-5 v-mid pa2"></div>
          <div className="dtc w-5 v-mid pa2">Type</div>
          <div className="dtc tl w-40 v-mid pa2">Question</div>
          <div className="dtc w-10 v-mid pa2">Publisher</div>
          <div className="dtc w-10 v-mid pa2">Last Updated</div>
          <div className="dtc w-10 v-mid pa2"></div>
          <div className="dtc w-20 v-mid pa2 tr"></div>
        </div>
      </div>
      {loading && Object.keys(polls).length === 0 ? (
        renderLoading()
      ) : error ? (
        <div className="bg-white dark-red h3 flex items-center">
          <div
            className={`dib h-100 mr3 bg-dark-red`}
            style={{ width: '10px' }}
          ></div>
          <span>
            An error append while fetching featured polls:{' '}
            {JSON.stringify(error.toString(), null, 2)}
          </span>
        </div>
      ) : (
        <FeaturedPollsList
          polls={polls}
          hasMore={hasMore}
          fetchFeaturedPolls={fetchFeaturedPolls}
          loading={loading}
        />
      )}
    </div>
  )
}

export default compose(
  connect(
    state => ({
      polls: selectFeaturedPolls(state),
      loading: state.polls.featured.loading,
      error: state.polls.featured.error,
      hasMore: hasMore(state, 'featured-polls'),
    }),
    { fetchFeaturedPolls }
  ),
  lifecycle({
    componentDidMount() {
      if (!this.props.polls.length > 0) {
        this.props.fetchFeaturedPolls()
      }
    },
  })
)(FeaturedPolls)



// WEBPACK FOOTER //
// ./src/components/LibraryPage/FeaturedPollsList.js